import { SFTPUserDTO } from "../DTO/sftpUserDTO";
import { BasicRequest } from "./basicRequest";

export class CreateSFTPUserRequest extends BasicRequest{

    public sftpUser!: SFTPUserDTO;

    constructor(){
        super();
    }
}